import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Hidden, InputBase, List, ListItem, ListItemText, Drawer, Checkbox, Select, MenuItem } from '@material-ui/core';
import { BackOnPrimaryIcon, TuneIcon, TocIcon, BackIcon, GoogleMapIcon, ExpandRightIcon, SwichGreenActiveIcon, SwichIcon, SwichActiveIcon, ArrowDownIcon } from '../../components/icons';
import CustomTypo from '../../components/CustomTypo';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import Container from '../../components/Container';
import {domainName, portal_config} from '../../../portal.config'
import classNames from 'classnames';
import DrawerCustom from '../../components/DrawerCustom';
import InfiniteScroll from 'react-infinite-scroll-component';
//import Slider from '@farbenmeer/react-spring-slider';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
  } from 'react-places-autocomplete';
import { ArrowBack } from '@material-ui/icons';
//import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
//import { Carousel } from 'react-responsive-carousel';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import MapInputComponent from '../../components/MapInputComponent';


const styles = theme => ({
    drawerPaper: {
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180deg, rgba(39,39,39,0.9) 0%, rgba(51,51,51,0.9) 37%, rgba(105,105,105,1) 100%);',

    },
    right: {
        padding: theme.spacing(6),
    },
    loading: {
        marginTop: theme.spacing(4)
    },
    map: {
        width: '100%',
        height: '100%',
    },
    locationIcon: {
        position: 'absolute',
        bottom: theme.spacing(60),
        right: theme.spacing(0)
    },
    buttonBack: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        //backgroundColor: theme.palette.background.tertiary,
        boxShadow: 'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8, 1, 0, 1),
        '&:hover': {
            opacity: 0.5,
        },
    },
    search: {
        // height: theme.spacing(10),
        // borderRadius: theme.spacing(10),
        // padding: theme.spacing(2, 8, 2, 4),
        // display: 'flex',
         alignItems: 'center',
        // backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        //top:theme.spacing(2.6),
        //right:theme.spacing(14),
    },
    search_list: {
        backgroundColor: theme.palette.background.secondary,
        width: '98%',
        position: 'absolute',
        top: theme.spacing(10),
        marginLeft: '1%',
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
        zIndex:999
    },
    input: {
        marginLeft: theme.spacing(2),
        //flex: 1,
        width: '200%',
    },
    footer: {
        position: 'absolute',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
        padding: theme.spacing(3),
    },
    cursor: {
        borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    tune: {
        position:'absolute',
        right: theme.spacing(1),
        borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    selectBox: {
        width:theme.spacing(26),
        position:'absolute',
        left: theme.spacing(3),
        cursor: "pointer",
        zIndex: 1000,
        textAlign:'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectCustomIcon:{
        marginTop:theme.spacing(1)
    },
    item_container: {
        width: 380,
        height: 120,
        padding: theme.spacing(0, 2, 0, 2),
        cursor: 'pointer',
    },
    item: {
        //backgroundColor: theme.palette.background.secondary,
        //borderRadius: theme.spacing(2)
    },
    item_image: {
        height: 120,
        width: '100%',
        objectFit: 'cover',
        borderTopLeftRadius: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
    },
    item_right: {
        //width: '60%',
        //marginLeft: theme.spacing(2),
        //marginRight: '5%',
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2)
    },
    tag: {
        backgroundColor: theme.palette.background.tertiary,
        width: 40,
        padding: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        borderColor: theme.palette.border.other,
        textAlign: "center",
    },
    merchant_image: {
        width: 48,
        height: 48,
        borderRadius: 48,
    },
    map_small: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    header_small:{
        position: 'absolute',
        top: theme.spacing(2),
        padding:theme.spacing(0,14,2,2)
    },
    buttonBack_small: {
        backgroundColor: theme.palette.background.secondary,
    },
    toc_bg: {
        position: 'absolute',
        bottom: theme.spacing(6),
        right: theme.spacing(15),
        width: theme.spacing(12),
        height: theme.spacing(12),
        borderRadius: 56,
        backgroundColor: theme.palette.button.primary.backgroundColor,
        cursor: 'pointer'
    },
    drawerRight:{
        padding: theme.spacing(4)
    },
    google_map:{
        cursor: 'pointer'
    },
    input2: {
        //backgroundColor: '#000000',
        marginLeft: theme.spacing(2),
        flex: 1,
        width: '200%',
        [theme.breakpoints.down('lg')]: {
            width: '130%',
        },
        [theme.breakpoints.down('md')]: {
            width: '170%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '120%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '130%',
        },
  },
  icon: {
    borderRadius: 4,
    width: 18,
    height: 18,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 18,
      height: 18,
      
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.primary.main,
    },
  },

});
function OfferMapView(props){
    const [search_value, setSearchValue] = useState('');
    const [merchantsByName, setMerchantByName] = useState([]);
    const [showList, onShowList] = useState(false);
    const [markerSelected, onSelectMaker] = useState(null);
    const [openRightDrawer, onShowRightDrawer] = useState(false);
    const [selectSearch, setSelectSearch] = useState('google');
    const onSelectAddress = (add) =>{
        //console.log("AAA add:", add)
        setSearchValue(add.address);
        props.resetMerchant()
        props.onSearchPlace(add)
    }
    const onSelectMerchant = (venue) =>{
        onShowRightDrawer(true);
        props.onSelectMerchant(venue)
    }
    const onHandleChange = (value) =>{
        setSearchValue(value);
        filterByName(value);
    }
    const filterByName = (name) =>{
        var merchants = props.merchants;
        //console.log(' filterByName merchants==',merchants)
        if (!name || !merchants) {
            setMerchantByName([]);
            onShowList(false);
        } else {
            var merchantsByName = merchants.filter(merchant => {
                return merchant.name.toLowerCase().includes(name.toLowerCase());
            })

            if (merchantsByName.length == 0) {
                setMerchantByName([]);
                onShowList(false);
            } else {
                setMerchantByName(merchantsByName);
                onShowList(true);
            }
           // console.log(' filterByName merchantsByName==',merchantsByName)
        }
    }
    const onSelect = (item, isHidePopup) =>{
        setSearchValue(item.name);
        onShowList(false);
        setMerchantByName([]);
        if (isHidePopup) {
            props.onShowMerchantsNearYou();
        }
        props.onSelectMerchant(item);
    }

    const handleChange = (address) => {
        setSearchValue(address);
        if(selectSearch!=='google'){
            filterByName(address);
        }
    };
    const handleSelect = (address) => {
        setSearchValue(address);
        geocodeByAddress(address)
          .then(results => {
               // console.log('handleSelect results=', results)
                props.onSearchPlace(results[0])
            })
          .catch(error => console.error('Error', error));
    };
    const onSelectSearchChange = (value) =>{
          console.log('select change = ', value)
          setSelectSearch(value);
    }

    const { open, classes, t, filter_options, filterSelected, onSelectFilter, onClearFilter,
    merchants, offers, onCloseMap, zoomMap, showLoading, onOpenFilter, onShowOfferDetail, centerRegion } = props;

    const searchSeleactData =[
        {
            label: t('Google'),
            value: 'google'
        },
        {
            label: t('Merchant'),
            value: 'merchant'
        }

    ];
    
   return (
       <Container showLoading={showLoading}>
           <Drawer
               variant="temporary"
               anchor={'top'}
               open={open}
               onClose={() => onCloseMap()}
               classes={{
                   paper: classes.drawerPaper
               }}
               ModalProps={{
                   keepMounted: true, // Better open performance on mobile.
               }}>
                   <MapCompomentFull classes={classes} t={t}
                       merchants = {merchants}
                       offers = {offers}
                       onCloseMap = {onCloseMap}
                       zoomMap = {zoomMap}
                       onSelectMerchant = {props.onSelectMerchant}
                       onOpenFilter = {onOpenFilter}
                       onShowOfferDetail = {onShowOfferDetail}
                       centerRegion = {centerRegion}
                       markerSelected = {markerSelected}
                       onSelectMerchant2 = {onSelectMerchant}
                       search_value = {search_value}
                       showList = {showList}
                       onSelectMaker = {onSelectMaker}
                       onShowRightDrawer = {onShowRightDrawer}
                       openRightDrawer = {openRightDrawer}
                       onHandleChange = {onHandleChange}
                       merchantsByName = {merchantsByName}
                       onSelect = {onSelect}
                       onSelectAddress = {onSelectAddress}
                       onDirection={props.onDirection}
                       handleChange={handleChange}
                       handleSelect={handleSelect}
                       selectSearch = {selectSearch}
                       searchSeleactData={searchSeleactData}
                       onSelectSearchChange={onSelectSearchChange}/>
               {/* </Hidden> */}
           </Drawer>
       </Container>
   );
}

function MapCompomentFull(props){
    const {  classes, t, merchants, offers, onCloseMap, zoomMap,onSelectMerchant, onOpenFilter, onShowOfferDetail, centerRegion, markerSelected, 
        onSelectMerchant2, openRightDrawer, onShowRightDrawer, search_value, showList, onSelectMaker,onHandleChange, merchantsByName, onSelect } = props
        let width = window.innerWidth
        //console.log('width===',width)
        let number = (width*40/100)/400; 
        let naturalSlideHeight = 40
        if(width<1280){
            number = (width*50/100)/400; 
        } 
        else if(width<600){
            number = width/500; 
           // naturalSlideHeight = 10
        }
        //console.log('number===',number)
        return(
    <Grid xs={12} item container className={classes.map_small}>
                    <DrawerCustom open={openRightDrawer} onClose={()=>onShowRightDrawer(!openRightDrawer)} fullScreen
                        children={
                            <Grid item className={classes.drawerRight}>
                                    <Grid xs={12} item className={classes.search} container alignContent='center'>
                                    <Select
                        disableUnderline
                        className={classes.selectBox}
                        defaultValue={props.searchSeleactData[0].value}
                        value={props.selectSearch}
                        onChange={(event)=>props.onSelectSearchChange(event.target.value)}
                        IconComponent={ArrowDownIcon}
                        classes={{ select: classes.selectCustom, icon: classes.selectCustomIcon }}
                    >
                        {props.searchSeleactData.map((item, index) => {
                            return <MenuItem value={item.value}><CustomTypo>{item.label}</CustomTypo></MenuItem>
                        })}
                    </Select>
                                        <MapInputComponent
                                                isSelectBox
                                                onHandleChange={props.selectSearch!=='google' ? props.onHandleChange : undefined}
                                                onSelectAddress={props.onSelectAddress}
                                                defaultAddress={props.search_value}
                                                />
                                        {portal_config[domainName].isOfferFilter && <TuneIcon className={classes.tune} onClick={() => onOpenFilter()} />}

                                        {showList && merchantsByName.length > 0 ? <Grid xs={12} item container><List className={classes.search_list}>
                                            {merchantsByName.map((item, index) => (
                                                <ListItem button key ={index} onClick={() => onSelect(item)}>
                                                    <ListItemText primary={item.name} />
                                                </ListItem>))}

                                        </List></Grid> : null}

                                    </Grid>
                                {offers && <Grid xs={12} item>
                                    <CustomTypo mg_top_xl color='onPrimary' variant='caption1'>{t('text_title_to_be_replace')}</CustomTypo>
                                    <CarouselProvider
                                        naturalSlideWidth={100}
                                        naturalSlideHeight={naturalSlideHeight}
                                        totalSlides={offers.length}
                                        visibleSlides={number}
                                        isPlaying={true}
                                        interval={2000}
                                        touchEnabled={false}
                                        dragEnabled={false}
                                    >
                                    <Slider>
                                    {offers.map((item, index) =>
                                        <Slide index={index}><OfferItem key={index} item={item} classes={classes} onClick={() => onShowOfferDetail(item)} onShowOfferDetail={onShowOfferDetail}/></Slide>
                                        )}
                                    </Slider>
                                    <ButtonBack>{"<"}</ButtonBack>
                                    <ButtonNext>{">"}</ButtonNext>
                                    </CarouselProvider>

                                    {/* <Carousel
                                    swipeable={true}
                                    draggable={true}
                                    showDots={false}
                                    responsive={responsive}
                                    ssr={true} // means to render carousel on server-side.
                                    infinite={true}
                                    autoPlay={true}
                                    autoPlaySpeed={3000}
                                    keyBoardControl={true}
                                    customTransition="all .5"
                                    transitionDuration={500}
                                    containerClass="carousel-container"
                                    removeArrowOnDeviceType={["tablet", "mobile"]}
                                    //deviceType={props.deviceType}
                                    dotListClass="custom-dot-list-style"
                                    itemClass="carousel-item-padding-40-px"
                                    >
                                    {offers.map((item, index) =>
                                        <div index={index}><OfferItem key={index} item={item} classes={classes} onClick={() => onShowOfferDetail(item)} onShowOfferDetail={onShowOfferDetail}/></div>
                                        )}
                                    </Carousel> */}
                                </Grid>}
                                {merchants && <Grid xs={12} item>
                                    <CustomTypo mg_top_xl color='onPrimary' variant='caption1'>{t('merchant_near_you')}</CustomTypo>
                                    <Grid xs={12} item  >
                                        {merchants.map((item, index) =>
                                            <MerchantItem key={index} item={item} classes={classes} onSelectMerchant={onSelectMerchant} onDirection={props.onDirection}/>
                                        )}
                                    </Grid>
                                </Grid>}
                            </Grid>
                        }

                    />
                    
                    <GoogleMapComponent center={centerRegion} zoom={zoomMap}>
                                {merchants ? merchants.map((venue, index) => {
                                    var location = venue.location;
                                    var address = location.address
                                    if (location && location.lat && location.lon) {

                                        return (
                                            <GoogleMapMarker
                                                info={{ title: venue.name, description: address, id: venue.id, contact_info: venue.contact_info }}
                                                key={index}
                                                lat={location.lat}
                                                lng={location.lon}
                                                onClick={onSelectMaker}
                                                markerSelected={markerSelected}
                                                onSelect={() => onSelectMerchant2(venue)}
                                            />
                                        )
                                    }
                                }) : null}
                            </GoogleMapComponent>
                            <Grid xs={12} item container className={classes.header_small}>
                                <Grid xs={2} sm={1} item onClick={() => onCloseMap()} container alignItems='center'>
                                    <Grid className={classNames(classes.buttonBack,classes.buttonBack_small)} >
                                        <BackIcon />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* <Grid Grid xs={12} item container className={classes.footer}> */}
                                <Grid item className={classes.toc_bg} onClick={()=>onShowRightDrawer(!openRightDrawer)} container justify='center' alignItems='center'>
                                    <TocIcon/>
                                </Grid>
                            {/* </Grid> */}
                    </Grid>
)
}

function MerchantItem(props) {
    const { classes, item, onSelectMerchant, onDirection } = props

    var distance = item.location && item.location.distance ? item.location.distance.toFixed(2) : null;
    var address = item.location && item.location.address ? item.location.address : "";
    var phone_number = null;
    var email = null;
    if (item.contact_info){
        item.contact_info.forEach((item)=>{
            if (item.type==='PHONE'){
                phone_number = item.value;
            }
            else if(item.type==='EMAIL'){
                email = item.value;
            }
        })
    }
    var covertToKM = 0;
    if (distance)
        covertToKM = distance * 1.6;
    if (covertToKM)
        covertToKM = covertToKM.toFixed(2);

    return (
        <Grid xs={12} item container onClick={() => onSelectMerchant(item)} className={classes.cursor}>
            <Grid xs={3} sm={2} item container justify='center' alignItems='center'>
                <MerchantItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail_merchant)} />
            </Grid>
            <Grid xs={9} sm={10} item className={classes.merchant_right} container>
                <Grid item xs={11}>
                    <Grid xs={12} item >
                        <CustomTypo variant='subtitle2' color='onPrimary'>{item.name}</CustomTypo>
                    </Grid>
                    {address ? <Grid xs={12} item >
                        <CustomTypo variant='description' color='onPrimary'>{address}</CustomTypo>
                    </Grid> : null}
                    {phone_number ?
                        <CustomTypo variant='description' color='onPrimary'>{phone_number}</CustomTypo>
                        : null}
                    {email ?
                        <CustomTypo variant='description' color='onPrimary'>&nbsp;•&nbsp;{email}</CustomTypo>
                        : null}
                    {distance ?
                        <CustomTypo variant='description' color='onPrimary' >&nbsp;•&nbsp;{covertToKM} km ({distance} mi)</CustomTypo>
                        : null}
                        
                </Grid>
                <Grid item xs={1} container justify='flex-end' onClick={()=>onDirection(item.location)} className={classes.google_map}>
                    <GoogleMapIcon/>
                </Grid> 
                <Grid item xs={12}>
                    <hr />
                </Grid>
               
            </Grid>
            
        </Grid>


    )
}

function MerchantItemImage(props) {
    const { classes, image } = props;

    if (image) {
        return <img src={image.url} className={classes.merchant_image} />
    } else {
        return (
            <div>
            </div>
            // <View style={home_styles.item_container_icon}>
            //     <GiftIcon style={[main_styles.icon_large, main_styles.icon_color_disable]} />
            // </View>
        )
    }
}
function OfferItem(props) {
    const { classes, item } = props


    return (
        <div className={classes.item_container}>
            {/* <Grid xs={12} sm={12} md={6} item container direction = 'row' > */}
            <Grid xs={12} item container className={classes.item} onClick={()=>props.onShowOfferDetail(item)}>
                <Grid xs={4} xl={4} item container>
                    <OfferItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail)} />
                </Grid>
                <Grid xs={8} xl={8} item container className={classes.item_right}>
                    {item.industry_name && <Grid xs={12} >
                        <div className={classes.tag}>
                            <CustomTypo variant='body2' color='tertiary'>{item.industry_name}</CustomTypo>
                        </div>
                    </Grid>}
                    <Grid xs={12} item container>
                        <CustomTypo variant='h6'>{item.owned_by.name}</CustomTypo>
                    </Grid>
                    <Grid xs={12} item container>
                        <CustomTypo variant='body2' color='danger'>{item.name}</CustomTypo>
                    </Grid>
                </Grid>
            </Grid>
            {/* </Grid> */}
        </div>

    )
}


function OfferItemImage(props) {
    const { classes, image } = props;

    if (image) {
        return <img src={image.url} className={classes.item_image} />
    } else {
        return (
            <div>
            </div>
            // <View style={home_styles.item_container_icon}>
            //     <GiftIcon style={[main_styles.icon_large, main_styles.icon_color_disable]} />
            // </View>
        )
    }
}
export default withStyles(styles)(withTranslation()(OfferMapView));